<template>
  <div class="ly_container">
    <div v-if="isTutorial">
      <MaterialCard class="ly_card" title="1.概要">
        <div class="el_card_content">
          「人づきあいのスキル診断」ではいくつかの質問に答えていただきます。これらに回答することで、あなたの人づきあいのスキルが診断されます。
        </div>
        <div class="el_card_content_plan">
          このスキル診断は約
          <div class="el_card_content_time">15分</div>
          かかります。
        </div>
      </MaterialCard>
      <MaterialButton
        class="ly_round_button"
        text="次へ"
        font-size="36px"
        padding="17px 56px 17px 56px"
        @click="isTutorial = false"
      >
      </MaterialButton>
    </div>
    <div v-else>
      <MaterialCard class="ly_card" title="2.進め方">
        <div class="el_card_content">
          今から、①から③までの３コマのイラスト付きで、学校生活に関するストーリーを読んでいただきます。<br /><br />
          各ストーリーにおける①から③までで、主語が省略されている場合、主語は「私」です。<br /><br />
          ストーリーの状況にあなた自身がいると想像してください。
        </div>
      </MaterialCard>
      <MaterialButton
        class="ly_round_button"
        text="例題へ"
        link="example"
        font-size="36px"
        padding="17px 56px 17px 56px"
      >
      </MaterialButton>
    </div>
  </div>
</template>

<script>
import MaterialCard from '../molcules/MaterialCard'
import MaterialButton from '../atoms/MaterialButton'
export default {
  name: 'Tutorial',
  components: { MaterialButton: MaterialButton, MaterialCard: MaterialCard },
  data: () => ({
    isTutorial: true,
  }),
}
</script>

<style scoped>
.ly_container {
  position: relative;
}
.ly_card {
  position: relative;
  top: 73px;
  margin-right: auto;
  margin-left: auto;
}
.el_card_content {
  text-align: left;
  padding-top: 73px;
  padding-left: 63px;
  width: 602px;
  /* height: 152px; */
  font-family: Noto Sans JP;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 35px;
}

.el_card_content_plan {
  display: flex;
  font-size: 28.9555px;
  line-height: 42px;
  align-items: center;
  padding-top: 85px;
  padding-left: 63px;

  color: #6b6b6b;
}

.el_card_content_time {
  font-style: normal;
  font-weight: normal;
  font-size: 38.9934px;
  line-height: 56px;
  margin-left: 28px;
  margin-right: 28px;
  /* identical to box height */

  display: flex;
  justify-content: center;
  align-items: center;

  color: #ffffff;

  width: 121.85px;
  height: 121.85px;
  left: 696.11px;
  top: 497.83px;

  border-radius: 61.5px;
  background: #ffa4a4;
}
.ly_round_button {
  position: relative;
  top: 116px;
  left: 270px;
}
</style>
